<template>
    <div class="text-align">
        <div v-show="isAuthorized">
            <div style="text-align: center !important">
                <div class="alert alert-light-success" style="margin-top: 10px">
                    <label>{{ $t("AUTHORIZATION.authorized") }} {{ $t("AUTHORIZATION.redirect") }} {{ redirectCountdown }}</label>
                </div>
            </div>
        </div>
        <div v-show="isAuthorizedError">
            <div style="text-align: center !important">
                <div class="alert alert-light-danger" style="margin-top: 10px">
                    <label>{{ $t("AUTHORIZATION.authorizedError") }} {{ $t("AUTHORIZATION.redirect") }} {{ redirectCountdown }}</label>
                    <br />
                    <label>{{ GetErrorMessage() }}</label>
                </div>
            </div>
        </div>
        <div v-show="isAuthorizing" style="text-align: center !important">
            <div v-show="isWaitingAuthorization">
                <div style="margin-top: 15%" class="spinner spinner-md"></div>
                <br />
                <label>{{ $t("AUTHORIZATION.awaitingAuthorization") }}</label>
            </div>
        </div>
        <div v-show="!isAuthorizing">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{ active: selectedTab === 'DocuSign' }"
                       aria-current="page"
                       role="button"
                       @click="selectedTab = 'DocuSign'">
                        DocuSign
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{ active: selectedTab === 'D4Sign' }"
                       role="button"
                       @click="selectedTab = 'D4Sign'">
                        D4Sign
                    </a>
                </li>
            </ul>
            <div v-if="selectedTab === 'DocuSign'">
                <AuthorizationDocuSign />
            </div>
            <div v-if="selectedTab === 'D4Sign'">
                <AuthorizationD4Sign />
            </div>
        </div>
    </div>
</template>

<script>
    import AuthorizationDocuSign from './AuthorizationDocuSign.vue';
    import AuthorizationD4Sign from './AuthorizationD4Sign.vue';
    import SharedMixin from "./../mixins/SharedMethods.js";
    import PlatformUids from "../shared/platformUids.js";

    export default {
        name: "Authorization",
        components: {
            AuthorizationDocuSign,
            AuthorizationD4Sign,
        },
        mixins: [SharedMixin],
        props: {
            msg: String,
            language: String,
        },
        data() {
            return {
                platformUids: PlatformUids,
                selectedTab: 'DocuSign',
                codeZeev: "",
                isAuthorizing: false,
                isAuthorized: false,
                isAuthorizedError: false,
                isWaitingAuthorization: false,
                isAuthorizingErr: false,
                msgTimeout: 5,
                displayMsgTimeout: 0,
                redirectCountdown: 5,
                selectedService: '',
                platforms: {
                    list: [],
                    docuSignData: {
                        uId: PlatformUids.DocuSign,
                        name: "",
                        integrationKey: "",
                        integrationKeyIsErr: false,
                        secretKey: "",
                        secretKeyIsErr: false,
                        hrefUriCode: "",
                        code: "",
                        urlRedirect: window.location.host,
                    },
                    docuSignDemoData: {
                        uId: PlatformUids.DocuSignDemo,
                        name: "",
                        integrationKey: "",
                        integrationKeyIsErr: false,
                        secretKey: "",
                        secretKeyIsErr: false,
                        hrefUriCode: "",
                        code: "",
                        urlRedirect: "http://localhost:5000/",
                    },
                },
            };
        },
        watch: {
            isAuthorized(newVal) {
                if (newVal) {
                    this.StartCountdown();
                }
            },
            isAuthorizedError(newVal) {
                if (newVal) {
                    this.StartCountdown();
                }
            }
        },
        created() {
            var lang = this.$route.params.lang;
            this.setLanguage(lang);
            this.$i18n.locale = lang;
            this.OnLoadAuthorize();
            this.DocuSignAuthorized();
            this.DocuSignDemoAuthorized();
        },
        methods: {
            GetErrorMessage() {
                return localStorage.getItem("errMsg");
            },
            StartCountdown() {
                const countdownInterval = setInterval(() => {
                    if (this.redirectCountdown > 0) {
                        this.redirectCountdown--;
                    } else {
                        clearInterval(countdownInterval);
                        window.close();
                        window.location.reload();
                    }
                }, 1000);
            },
            DocuSignAuthorized: function () {
                this.platforms.docuSignData.code = this.$route.query.code;
                this.codeZeev = localStorage.getItem("codeZeev");
                var platformUid = localStorage.getItem("platformUidDocuSign");
                localStorage.removeItem("platformUidDocuSign");

                if (this.platforms.docuSignData.uId != platformUid) return;

                this.isAuthorizing = true;
                this.isWaitingAuthorization = true;

                if (!this.platforms.docuSignData.code) {
                    localStorage.setItem("errMsg", "Docusign Code is null");
                    this.isAuthorizingErr = true;
                    return;
                }

                this.platforms.docuSignData.integrationKey = localStorage.getItem(
                    "integrationKeyDocuSign"
                );
                localStorage.removeItem("integrationKeyDocuSign");
                this.platforms.docuSignData.secretKey =
                    localStorage.getItem("secretKeyDocuSign");
                localStorage.removeItem("secretKeyDocuSign");

                let params = {
                    Uid: this.platforms.docuSignData.uId,
                    codeZeev: this.codeZeev,
                    code: this.platforms.docuSignData.code,
                    keyApplication: this.platforms.docuSignData.integrationKey,
                    secretKey: this.platforms.docuSignData.secretKey,
                };

                let url = `${this.fullTopUrlWithoutAppCode()}/internal/v1/authorization/${platformUid}`;
                this.$http.post(url, params).then(
                    (response) => {
                        if (!response.ok) {
                            this.isAuthorizingErr = true;
                            localStorage.setItem("isDocuSignErr", true);
                            this.isWaitingAuthorization = false;
                            this.isAuthorizedError = true;
                            localStorage.setItem("errMsg", response.content);
                        } else if (!response.body.success) {
                            this.isAuthorizingErr = true;
                            localStorage.setItem("isDocuSignErr", true);
                            this.isWaitingAuthorization = false;
                            this.isAuthorizedError = true;
                            localStorage.setItem("errMsg", response.body.content);
                        } else {
                            this.isAuthorizingErr = false;
                            this.isWaitingAuthorization = false;
                            this.isAuthorized = true;
                            localStorage.setItem("isDocuSignErr", false);
                        }
                    },
                    (error) => {
                        this.isAuthorizingErr = true;
                        this.isWaitingAuthorization = false;
                        localStorage.setItem("isDocuSignErr", true);
                        console.error(error);
                    }
                );
            },
            DocuSignDemoAuthorized: function () {
                this.platforms.docuSignDemoData.code = this.$route.query.code;
                this.codeZeev = localStorage.getItem("codeZeev");
                var platformUid = localStorage.getItem("platformUidDocuSignDemo");
                localStorage.removeItem("platformUidDocuSignDemo");

                if (this.platforms.docuSignDemoData.uId != platformUid) return;

                this.isAuthorizing = true;
                this.isWaitingAuthorization = true;
                if (!this.platforms.docuSignDemoData.code) {
                    localStorage.setItem("isDocuSignDemoErr", true);
                    localStorage.setItem("errorMsg", "Docusign Code is null");
                    this.isAuthorizingErr = true;
                    window.close();
                    return;
                }

                this.platforms.docuSignDemoData.integrationKey = localStorage.getItem(
                    "integrationKeyDocuSignDemo"
                );
                localStorage.removeItem("integrationKeyDocuSignDemo");
                this.platforms.docuSignDemoData.secretKey = localStorage.getItem(
                    "secretKeyDocuSignDemo"
                );
                localStorage.removeItem("secretKeyDocuSignDemo");

                let params = {
                    uid: this.platforms.docuSignDemoData.uId,
                    codeZeev: this.codeZeev,
                    code: this.platforms.docuSignDemoData.code,
                    keyApplication: this.platforms.docuSignDemoData.integrationKey,
                    secretKey: this.platforms.docuSignDemoData.secretKey,
                };
                let url = `${this.fullTopUrlWithoutAppCode()}/internal/v1/authorization/${platformUid}`;
                this.$http.post(url, params).then(
                    (response) => {
                        if (!response.ok) {
                            this.isAuthorizingErr = true;
                            localStorage.setItem("isDocuSignDemoErr", true);
                            this.isWaitingAuthorization = false;
                            this.isAuthorizedError = true;
                            localStorage.setItem("errMsg", response.content);
                        } else if (!response.body.success) {
                            this.isAuthorizingErr = true;
                            localStorage.setItem("isDocuSignDemoErr", true);
                            this.isWaitingAuthorization = false;
                            this.isAuthorizedError = true;
                            localStorage.setItem("errMsg", response.body.content);
                        } else {
                            this.isAuthorizingErr = false;
                            this.isWaitingAuthorization = false;
                            this.isAuthorized = true;
                            localStorage.setItem("isDocuSignDemoErr", false);
                        }
                    },
                    (error) => {
                        this.isAuthorizingErr = true;
                        this.isWaitingAuthorization = false;
                        localStorage.setItem("isDocuSignDemoErr", true);
                        console.error(error);
                    }
                );
            },
            OnLoadAuthorize: function () {
                this.codeZeev = this.$route.params.obj;
                if (this.codeZeev == undefined) return;
                localStorage.setItem("codeZeev", this.codeZeev);
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .text-align {
        text-align: left;
    }
</style>